import { render, staticRenderFns } from "./PositionPicker.vue?vue&type=template&id=b632119a&scoped=true"
import script from "./PositionPicker.vue?vue&type=script&lang=js"
export * from "./PositionPicker.vue?vue&type=script&lang=js"
import style0 from "./PositionPicker.vue?vue&type=style&index=0&id=b632119a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b632119a",
  null
  
)

export default component.exports